import React, { useEffect } from 'react';
import SpotifyWebApi from 'spotify-web-api-js';
import './App.css';
import { getTokenFromURL } from './components/API/spotify_requests';
import Login from './components/Login/Login';
import Player from './components/Player/Player';
import { useDataLayerValue } from './Context_API/Data_Layer';

const spotify = new SpotifyWebApi();

function App() {
  const [{ user, token }, dispatch] = useDataLayerValue();

  useEffect(() => {
    const hash = getTokenFromURL();
    window.location.hash = "";
    const _token = hash.access_token;

    if (_token) {
      // dispatch set token in reducer
      dispatch({
        type: "SET_TOKEN",
        token: _token
      });

      spotify.setAccessToken(_token);
      spotify.getMe().then((user) => {

        // dispatch set user in reducer
        dispatch({
          type: "SET_USER",
          user: user
        });
      });

      spotify.getUserPlaylists().then(playlists => {
        dispatch({
          type: "SET_PLAYLISTS",
          playlists: playlists
        })
      });

    }

    spotify.getPlaylist("37i9dQZEVXcVqqouoPMWZK").then(response => (
      dispatch({
        type: "SET_DISCOVER_WEEKLY",
        discover_weekly: response
      })
    ))

 },[])

  return (
    <div className="app">
    
     {token ? (
     <Player spotify={spotify}/>
     ) 
     : (
     <Login />
     )

    }
    </div>
  );
} 

export default App;
